import { render } from "./Tables.vue?vue&type=template&id=2fa24e3a&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=2fa24e3a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96L/0/prj/cashier/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa24e3a"]])

export default __exports__